import config from '../../helpers/config';

export default (/* itemId */) => (/* dispatch, getState */) => config.plpUrl.estimate;
